import React from 'react';
import { withStyles, Grid, Typography, CircularProgress, } from '@material-ui/core';
import PropTypes from 'prop-types';

class ChartCircle extends React.Component {

    render() {
        const { classes, score1, score2, title } = this.props;
        let lv = (score1 + score2) == 0 ? 0 : (score2 / (score1 + score2)) * 100;



        return (
            <Grid container direction='column' alignItems='center' style={{ flex: 1 }}>
                <Grid container direction='row' alignItems='center' justifyContent='center'>
                    <Typography style={{ color: '#0D0D0D', fontSize: 10, marginRight: 4 }}>{score2 == 0 && score1 == 0 ? '' : score1}</Typography>
                    <Grid container direction='column' alignItems='center' justifyContent='center' className={(score1 + score2) == 0 ? classes.circleBack1 : classes.circleBack}>
                        <CircularProgress variant='determinate' thickness={4} size={40} value={lv} style={{ color: '#358BF3', marginLeft: 0 }} />
                    </Grid>
                    <Typography style={{ color: '#0D0D0D', fontSize: 10, marginLeft: 4 }}>{score2 == 0 && score1 == 0 ? '' : score2}</Typography>
                </Grid>
                <Grid container direction='row' alignItems='center' justifyContent='center'>
                    <Typography style={{ color: '#898989', fontSize: 10, marginTop: 4 }}>{title}</Typography>
                </Grid>
            </Grid>
        );
    }
}

ChartCircle.propTypes = {
    title: PropTypes.string.isRequired,
    score1: PropTypes.number.isRequired,
    score2: PropTypes.number.isRequired
}

export default withStyles((theme) => ({
    circleBack: {
        border: 'solid 4px #FC2D33',
        borderRadius: 20,
        height: 40,
        width: 40,
    },
    circleBack1: {
        border: 'solid 4px #F7F7F7',
        borderRadius: 20,
        height: 40,
        width: 40,
    },
}))(ChartCircle);